import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_BASE });

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 — redirect to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });

// Leads
export const getLeads = (params) => api.get('/leads', { params });
export const getLead = (id) => api.get(`/leads/${id}`);
export const createLead = (data) => api.post('/leads', data);
export const updateLead = (id, data) => api.patch(`/leads/${id}`, data);
export const movLeadStage = (id, data) => api.patch(`/leads/${id}/stage`, data);
export const getLeadMoves = (id) => api.get(`/leads/${id}/moves`);
export const moveLeadToNode = (id, data) => api.patch(`/leads/${id}/move`, data);
export const addLeadActivity = (id, data) => api.post(`/leads/${id}/activity`, data);
export const setLeadFollowUp = (id, data) => api.patch(`/leads/${id}/follow-up`, data);
export const deleteLead = (id) => api.delete(`/leads/${id}`);
export const assignLead = (id, data) => api.patch(`/leads/${id}/assign`, data);
export const getLeadStats = () => api.get('/leads/stats');
export const getUpworkCandidates = () => api.get('/leads/upwork-retainer-candidates');

// Users (admin only)
export const getUsers = () => api.get('/users');
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.patch(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);

export default api;
